import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import TransactSignStep from './TransactSignStep';

const CustomFiled = ({ property, value }) => {
  const { t } = useTranslation();
  return (
    <Typography variant='body1'>
      {value &&
    <>
      <b>{t(`infoAboutStep:${property}`)}: </b> {value}
    </>
      }
    </Typography>
  );
};

CustomFiled.propTypes = {
  property: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number])
};

function InfoAboutStep ({ type, props, flow }) {
  const { t } = useTranslation();
  const linkGoogleMaps = ({ latitude, longitude }) => (
    <>
      <b>Lan: </b>{latitude},
      <b>Lon: </b>{longitude}
      <Link target='_blank' to={{
        pathname: `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}` }}> {t('infoAboutStep:seeGoogleMaps')}</Link>
    </>
  );

  const renderBody = (body) => {
    if (!body) return null;
    const { navegador, appVersion, geolocation, platform, vendor } = body.deviceInfo || {};
    const { provider } = body;
    return (
      <div>
        <CustomFiled property={'navegador'} value={navegador} />
        <CustomFiled property={'appVersion'} value={appVersion} />
        <CustomFiled property={'platform'} value={platform} />
        <CustomFiled property={'vendor'} value={vendor} />
        {geolocation &&
        <CustomFiled property={'geolocation'} value={linkGoogleMaps(geolocation)} />}
        {provider &&
        <CustomFiled property={'provider'} value={provider} />}
      </div>
    );
  };

  const renderSignType = (signType) => (
    <CustomFiled property={'signType'} value={signType} />
  );

  const renderTemplateId = (templateId) => (
    <CustomFiled property={'templateId'} value={templateId} />
  );

  const renderFea = ({ enable, userData }) => {
    if (enable === 'false') return null;
    return (
    <>
      <CustomFiled property={'name'} value={userData.nombre} />
      <CustomFiled property={'lastName'} value={userData.apellidos} />
      <CustomFiled property={'email'} value={userData.email} />
      <CustomFiled property={'phone'} value={userData.telefono} />
      <CustomFiled property={'rut'} value={userData.rut} />
      <CustomFiled property={'serie'} value={userData.serie} />
      <CustomFiled property={'typeCert'} value={userData.tipo_cert} />
    </>
    );
  };

  const aproveStep = (step) => {
    return (
      <>
        {renderBody(step.body)}
      </>
    );
  };

  const padSignStep = (step) => {
    return (
      <>
        {renderBody(step.body)}
      </>
    );
  };

  const transactSignStep = (step, flow) => {
    return (
      <>
        {renderBody(step.body)}
        {step.signResponse && <TransactSignStep signResponse={step.signResponse} flow={flow} />}
      </>
    );
  };

  const attendedSignStep = (step) => {
    return (
      <>
        {renderBody(step.body)}
        {renderSignType(step.signType)}
        {step.fea && renderFea(step.fea)}
      </>
    );
  };

  const stampSignStep = (step) => {
    return (
      <>
        {renderSignType(step.signType)}
      </>
    );
  };

  const subFlows = (step) => {
    return (
      <>
        {renderTemplateId(step.templateId)}
      </>
    );
  };

  const renderInfoAboutStep = (property) => (props, flow) => {
    const obj = {
      timeStampStep: () => null,
      qrSignStep: () => null,
      otpSignStep: () => null,
      notificationStep: () => null,
      biometricSignStep: () => null,
      biometricOnBoardingStep: () => null,
      blockchainIdentitySignStep: () => null,
      stampSignStep,
      subFlows,
      aproveStep,
      padSignStep,
      transactSignStep,
      attendedSignStep,
      externalResolverStep: () => null,
      loadFilesStep: () => null
    };
    return obj[property](props, flow);
  };
  return renderInfoAboutStep(type)(props, flow);
}

InfoAboutStep.propTypes = {
  type: PropTypes.string.isRequired,
  props: PropTypes.object.isRequired
};

export default InfoAboutStep;
